/**
 * Add intrinsic yield (e.g. staking rewards) on top of IRM-based supply APY.
 * Intrinsic APY is external to the protocol so we simply add it to the final result.
 * Both inputs and output are in percentage (e.g. 5.0 = 5%).
 */
export function addIntrinsicAPY(irmAPY: number, intrinsicAPY: number | undefined): number {
  if (!intrinsicAPY || intrinsicAPY <= 0) return irmAPY
  return irmAPY + intrinsicAPY
}
